const currencyFormatters = new Map<string, Intl.NumberFormat>();

const getCurrencyFormatter = (currency: string): Intl.NumberFormat | undefined => {
  const cached = currencyFormatters.get(currency);
  if (cached) return cached;
  try {
    const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency });
    currencyFormatters.set(currency, formatter);
    return formatter;
  } catch {
    return undefined;
  }
};

/**
 * Formats a price amount and currency code into a human-readable string.
 *
 * @param amount - The price amount. Pass `undefined` when no price is available.
 * @param currency - ISO 4217 currency code (e.g. "USD"). Ignored when amount is 0 or undefined.
 * @param labels - Optional override labels for free/no-price cases. Defaults to plain strings.
 */
export function formatPrice(
  amount: number | undefined,
  currency: string | undefined,
  labels: { free?: string; noPrice?: string } = {}
): string {
  const { free = "Free", noPrice = "" } = labels;

  if (amount === undefined) return noPrice;
  if (amount === 0) return free;

  if (currency && currency.length === 3) {
    const formatter = getCurrencyFormatter(currency);
    if (formatter) return `${currency} ${formatter.format(amount)}`;
    return `${currency} ${amount}`;
  }

  return amount.toString();
}
